jQuery(function ($) {
	$('.bannerCarousel').slick({
		autoplay: true,
		autoplaySpeed: 5000,
		slidesToShow: 1,
		infinite: true,
		slidesToScroll: 1,
		arrows: false,
		// useAutoplayToggleButton: false,
	});

	function addOrRemoveNonSliderClasses() {
		$('.bannerCarousel').each(function () {
			if ($(this).find('.bannerCarousel__item').length == 1) {
				$(this)
					.find('.slick-autoplay-toggle-button')
					.css('display', 'none');
			}
		});
	}

	$(window).on('resize', function (e) {
		addOrRemoveNonSliderClasses();
	});

	addOrRemoveNonSliderClasses();
});
